module.exports = __webpack_public_path__ + "img/error.f1abcdbd.svg";